import { Backdrop, Box, CircularProgress } from "@mui/material";
import Form from "./Form";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  getGroupStatus,
  getPeriods,
  getUserCountries,
  reset,
  setState,
} from "./cgpgSlice";
import ProductGroupsTable from "./ProductGroupsTable";
import CustomerGroupsTable from "./CustomerGroupsTable";
import ButtonGroup from "./ButtonGroup";
import RejectSelectedModal from "./RejectSelectedModal";
import Comments from "./Comments";
import CollapseSection from "../../../components/ui/CollapseSection";
import MessageForCgPg from "./MessageForCgPg";
import RejectGroupModal from "./RejectGroupModal";
import ProductGroupSummary from "./ProductGroupSummary";
import CustomerGroupSummary from "./CustomerGroupSummary";

export default function CGPG() {
  const dispatch = useDispatch();
  const states = useSelector((store) => store.cgpgApproval);
  const {
    isLoading,
    groupStatusList,
    periods,
    productGroupsTable,
    customerGroupsTable,
  } = states;

  const loginState = useSelector((store) => store.login);
    const { globalSelectedCountryID } = loginState;

  useEffect(() => {
    dispatch(reset("refresh"));
    setDropdownsOnLoad();
    //if (countries.length === 0) {
    dispatch(getUserCountries());
    //}
    if (groupStatusList.length === 0) {
      dispatch(getGroupStatus());
    }
    if (periods.length === 0) {
      dispatch(getPeriods());
    }
    dispatch(setState("message", ""));
    dispatch(setState("severity", ""));
    dispatch(setState("messageOpen", false));
  }, []);

  function setDropdownsOnLoad() {
    dispatch(setState("selectedView", "Product Group"));
    dispatch(setState("selectedRows", []));
    dispatch(setState("rejectSelectedComment", ""));
    dispatch(setState("productGroupsTable", null));
    dispatch(setState("customerGroupsTable", null));
    dispatch(setState("clickedRowComment", ""));
    dispatch(setState("groupRowClicked", false));
    dispatch(setState("selectedGroupStatus", "All"));
    if (
      globalSelectedCountryID === null ||
      globalSelectedCountryID === "" ||
      globalSelectedCountryID === undefined
    ) {
      dispatch(setState("selectedCountry", "All"));
      dispatch(setState("selectedCountryID", 0));
    }

    dispatch(setState("selectedPeriod", "All"));
    dispatch(setState("searchText", ""));
  }

  return (
    <Box>
      <Box>
        <Backdrop
          sx={{
            color: "#fff",
            zIndex: (theme) => theme.zIndex.drawer + 1,
          }}
          open={isLoading}
        >
          <CircularProgress />
        </Backdrop>
      </Box>
      <Box>
        <MessageForCgPg />
      </Box>
      <CollapseSection title="Search for Group">
        <Form />
        <RejectGroupModal />
        {productGroupsTable !== null ? <ProductGroupsTable /> : null}
        {customerGroupsTable !== null ? <CustomerGroupsTable /> : null}
        <ButtonGroup />
        <RejectSelectedModal />
      </CollapseSection>
      <ProductGroupSummary />
      <CustomerGroupSummary />
      <CollapseSection title="Comments">
        <Comments />
      </CollapseSection>
    </Box>
  );
}
